import React from "react";
import styles from "./styles.module.scss";

interface WithdrawalHistoryShimmerProps {
  count?: number;
}

const WithdrawalHistoryShimmer: React.FC<WithdrawalHistoryShimmerProps> = ({
  count = 3,
}) => {
  return (
    <div className={styles.withdrawal_items_list}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className={styles.withdrawal_item}>
          {/* Right Section - Operation Details and Status */}
          <div className={styles.right_section}>
            <div className={styles.operation_container}>
              <div className={styles.status_icon} />
              <div className={styles.operation_text_container}>
                <div className={styles.operation_text} />
                <div className={styles.status_text} />
              </div>
            </div>
          </div>

          {/* Left Section - Amount and Date/Time */}
          <div className={styles.left_section}>
            <div className={styles.amount_container}>
              <span className={styles.amount} />
            </div>
            <div className={styles.date_time_container}>
              <div className={styles.time_container}>
                <span className={styles.date} />
                <div className={styles.clock_icon} />
                <span className={styles.time} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default WithdrawalHistoryShimmer;
